import parse from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';
import { WebsiteCookies } from "./website-cookies";

export class CommonAction {
    getPageFromUrl() {
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('page') || 1;
    }

    getKeyFromUrl(key) {
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    }

    getQueryInObject() {
        let parameters = window.location.search;
        if (parameters != '') {
            var search = parameters.split('?')[1];
            // parameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            parameters = decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')
            let jsonObject = {};

            for(let element of parameters.split(','))
            {

              let new_element = element.split(':');
              let key =  new_element[0].replace("\"", "").replace("\"", "");
              let value = new_element[1].replace("\"", "").replace("\"", "");
              if(jsonObject[key])
              {
                if(Array.isArray(jsonObject[key]))
                {
                   jsonObject[key].push(value)
                }
                else
                {
                    jsonObject[key] = [jsonObject[key], value]
                }
              }
              else
              {
                jsonObject[key] = value;
              }
            }
            parameters = jsonObject;
        }
        else {
            parameters = {};
        }
        return parameters;
    }

    convert_String_Into_Date(date_value) {
        if (typeof date_value == 'string' && date_value.includes(':')) {
            var split_date = date_value.split(':');
            var HH = split_date[0];
            var MM = split_date[1];
            var new_date = new Date();
            new_date.setHours(HH)
            new_date.setMinutes(MM);
            return new_date;
        }
        else {
            return date_value;
        }
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    lowerizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    changeDateFormatToYearMonthDay(dateString)
    {
        if(dateString && dateString.includes('/'))
        {
            return dateString.split('/').reverse().join('-');
        }
        else
        {
                return '';
        }
    }

    changeDateFormatToDayMonthYear(dateString)
    {
        if(dateString && dateString.includes('/'))
        {
            return dateString.split('/').reverse().join('/');
        }
        else
        {
                return '';
        }
    }

    changeDateFormatToYearMonthDayForwardSlash(dateString)
    {
        if(dateString && dateString.includes('/'))
        {
            return dateString.split('/').reverse().join('/');
        }
        else
        {
                return '';
        }
    }
    check_file_size(file,file_size)
    {
        if(file.size > file_size)
        {
            return false;
        }
        else
        {
            return true;
        }
    }

    getDateInYMDFormat(date) {
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();


      if(typeof mm == 'string')
      {
        if(!mm.includes('0'))
        {
          mm = '0'+mm
        }
      }
      else if(typeof mm == 'number')
      {
        if(mm<10)
        {
        mm = '0'+mm;
        }
      }

      return date = yyyy + '/' + mm + '/' + dd;
    }

    getDateInDMYFormat(date) {
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();


        if(typeof mm == 'string')
        {
          if(!mm.includes('0'))
          {
            mm = '0'+mm
          }
        }
        else if(typeof mm == 'number')
        {
          if(mm<10)
          {
          mm = '0'+mm;
          }
        }
        return date = dd + '/' + mm + '/' + yyyy;

    }

    async asyncAddParamsToUrl(queryParams, router)
    {
        await router.push({
                            pathname :  router.asPath.split('?')[0],
                            query    :  queryParams
                        })
    }

    paramsToUrlWithoutRouter(params, router)
    {
        const urlParams = new URLSearchParams(window.location.search);
        for(let key of Object.keys(params))
        {
          urlParams.set(key, params[key]);
        }
        let new_path = window.location.pathname+`?${urlParams}`
        window.history.pushState({}, null, new_path);
    }

    getParamsToUrlWithoutRouter(param)
    {
        let url = window.location.href;
        let url_param = new URL(url).searchParams.get(param);
        return url_param;
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    lowerizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    changeDateFormatToYearMonthDay(dateString) {
        return dateString.split('/').reverse().join('-');
    }

    switchAgencyClients(hash, session)
    {
      if(!hash){
        return false;
      }
        var result = true;
    var key_hash = Object.keys(hash)

        for(let key of key_hash){

            if (hash[key] && hash[key].length == 0 ){
                result = false;
                break
            }
        }

        if(session.role == "Administrator")
        {
            result  = false;
        }
        return result;
    }

    convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    };

    convertUrlToBase64(url){
      let promise = new Promise(function (resolve, reject) {
      // return null if image url is not valid
      if (!url) {
        resolve(null);
        return;
      }
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64String = reader.result;
              resolve(base64String);
            };
          reader.onerror = () => {
            resolve(null)
          };
        })
        .catch(error => {
          resolve(null);
        });
      });
      return promise;
    }

    getDateInString(selected_date)
    {
        if(typeof selected_date != 'undefined')
        {
            if(typeof selected_date == 'string')
            {
              return selected_date
            }
            else
            {
              return this.getDateInDMYFormat(selected_date)
            }
        }
        else
        {
            return this.getDateInDMYFormat(new Date())
        }
    }

    embedHttps(value)
    {
      let http_pattern = /^((http):\/\/)/;
      let https_pattern = /^((https):\/\/)/;
      if(http_pattern.test(value))
      {
          value = value.replace('http', 'https');
      }
      else if(!https_pattern.test(value))
      {
        value = "https://" + value;
      }
      return value;
    }

    pathOfHashKey(hash, value, path)
    {
        for(let key of Object.keys(hash))
        {
            if(typeof hash[key] == 'string')
            {
              if(hash[key] == value)
              {
                path = path.length > 0 ? `${path}.${key}` : `${key}`;
                break;
              }
              else
              {
                path = '';
              }
            }
            else if(typeof hash[key] == 'object' && hash[key] != null && Object.keys(hash[key]).length > 0)
            {
              path = path.length > 0 ? `${path}.${key}` : `${key}`;
              path = this.pathOfHashKey(hash[key], value, path)
            }
        }

        return path;
    }

    html_txt_parsing(message_body) 
    {
      try {
        message_body = sanitizeHtml(message_body, {allowedTags: false, allowedAttributes: false});
        return parse(`${message_body}`);
      }
      catch (err) {
        return message_body
      }
    }

    html_txt_parsing_text_only(message_body) {
      try {
        message_body = sanitizeHtml(message_body, {allowedTags: [], allowedAttributes: {}})
        return parse(`${message_body}`);
      }
      catch (err) {
        return message_body
      }
    }

    checkDimension(selected_file, validationWidth, validationHeight, type) {
      var k_this = this;
      let promise = new Promise(function (resolve, reject) {
        var reader = new FileReader();
        if(typeof selected_file != 'undefined')
        {
            reader.readAsDataURL(selected_file);
            reader.onload = (event)=>{
            var imageFile = new Image();
            imageFile.src = event.target.result;
            imageFile.onload = (event)=>{
                                    let image_height = event.target.height;
                                    let image_width = event.target.width;
                                    if(image_height < validationHeight || image_width < validationWidth)
                                    {
                                      resolve(false);
                                    }
                                    else
                                    {
                                      resolve(true);
                                    }
                                  }
                                }
        }
        else
        {
            resolve(false);
        }
      });
      return promise;
    }

    addHttpOrHttps(link){
      let downcaseUrl = link.toLowerCase()
      if (downcaseUrl.indexOf("http://") == 0 || downcaseUrl.indexOf("https://") == 0) {
        return downcaseUrl;
      }
      else{
        return "https://"+downcaseUrl
      }
    }

    base64ToUrl(base_str){
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }

    checkMaxDimension(selected_file, validationWidth, validationHeight, type) {
      var k_this = this;
      let promise = new Promise(function (resolve, reject) {
        var reader = new FileReader();
        if(typeof selected_file != 'undefined')
        {
            reader.readAsDataURL(selected_file);
            reader.onload = (event)=>{
            var imageFile = new Image();
            imageFile.src = event.target.result;
            imageFile.onload = (event)=>{
                                    let image_height = event.target.height;
                                    let image_width = event.target.width;
                                    if(image_height > validationHeight || image_width > validationWidth)
                                    {
                                      resolve(false);
                                    }
                                    else
                                    {
                                      resolve(true);
                                    }
                                  }
                                }
        }
        else
        {
            resolve(false);
        }
      });
      return promise;
    }

    checkMinWidth(selected_file, validationWidth, type){
      var k_this = this;
      let promise = new Promise(function (resolve, reject) {
        var reader = new FileReader();
        if(typeof selected_file != 'undefined')
        {
            reader.readAsDataURL(selected_file);
            reader.onload = (event)=>{
            var imageFile = new Image();
            imageFile.src = event.target.result;
            imageFile.onload = (event)=>{
                                    let image_width = event.target.width;
                                    if(image_width < validationWidth)
                                    {
                                      resolve(false);
                                    }
                                    else
                                    {
                                      resolve(true);
                                    }
                                  }
                                }
        }
        else
        {
            resolve(false);
        }
      });
      return promise;
    }

    sidebarLogoUrl(){
      var website_cookie = new WebsiteCookies();
      return website_cookie.getCookie('sidebar_logo_url') || '';
    }

    headerLogoUrl(){
      var website_cookie = new WebsiteCookies();
      return website_cookie.getCookie('header_logo_url') || '';
    }
}
